import Api from '@/utils/axios/Api';
const Http = Api.getInstance();



export const TypeCreate = (payload:Object) => {
    return new Promise((resolve, reject) => {
        Http.post('types' , payload)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}



export const TypeUpdate = (id :number , payload:Object) => {
    return new Promise((resolve, reject) => {
        Http.put(`types/${id}` , payload)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}

export const TypeFind = (id: number) => {
    return new Promise((resolve, reject) => {
        Http.get(`types/${id}`)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}



export const TypeDelete = (id: number) => {
    return new Promise((resolve, reject) => {
        Http.delete(`types/${id}`)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}

